







import { Component, Prop, Vue } from 'vue-property-decorator'
import { PropType } from 'vue'
import { TrelloCard } from '@/TrelloClient'

@Component({
    props: {
        cardId: String,
    },
})
export default class extends Vue {

    buttonHandler() {
        this.$store.dispatch('fetchActiveCard', (this as any).cardId).then(() => {
            this.$bvModal.show('card-details-modal')
        })
    }

}
